module.exports = __webpack_public_path__ + "img/Weightage.4eb5020a.svg";